import type { ModOrigin } from '../api/catalog';
import { ca } from '../i18n/ca';
import { modOriginLabel } from './modOriginLabel';

function titleOf(o: ModOrigin): string {
  const t = ca.modOrigin;
  switch (o.kind) {
    case 'game':
      return t.gameTitle;
    case 'cdlc':
      return t.cdlcTitle;
    case 'mod':
      return t.modTitle(o.workshopId);
    case 'unread':
      return t.unreadTitle;
    default:
      return t.unknownTitle;
  }
}

const ICON: Record<string, string> = {
  game: 'bi-controller',
  cdlc: 'bi-bag',
  mod: 'bi-steam',
};

/**
 * The origin as a chip, the way the terrain tab's origin column shows a map's
 * mod: the Steam mark on a Workshop mod, the name beside it. Nothing at all
 * when the platform is older than the field.
 */
export function ModOriginChip({ origin }: { origin?: ModOrigin | null }) {
  if (!origin) return null;
  const quiet = origin.kind === 'unknown' || origin.kind === 'unread';
  const icon = ICON[origin.kind];
  return (
    <span className={`chip mod-origin ${quiet ? 'muted' : ''}`} title={titleOf(origin)}>
      {icon && <i className={`bi ${icon}`} aria-hidden="true" />} {modOriginLabel(origin)}
    </span>
  );
}

/** A loadout's mods, one chip each; nothing when there is nothing to say. */
export function ModOriginChips({ origins }: { origins?: ModOrigin[] | null }) {
  if (!origins || origins.length === 0) return null;
  return (
    <span className="mod-origins" role="list" aria-label={ca.modOrigin.loadoutLabel}>
      {origins.map((o, i) => (
        <span role="listitem" key={`${o.kind}:${o.name ?? ''}:${o.workshopId ?? ''}:${i}`}>
          <ModOriginChip origin={o} />
        </span>
      ))}
    </span>
  );
}
